<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="text-left">
        {{ $t('GENERAL.LABEL.DESCRIPTION') }}
      </div>
      <div class="pointer text-right c-medium-gray">
        <div @click="showDescription = !showDescription">
          <i
            class="fal fa-chevron-down mr-1 rotate"
            :class="{ down: showDescription }"
          ></i>
        </div>
      </div>
    </div>
    <div class="my-2" v-if="showDescription">
      <HMCustomContent
        class="event-description"
        :html="descriptionHtml"
        :json="descriptionJson"
      />
    </div>
  </div>
</template>

<script>
import HMCustomContent from '@/web/components/common/HMCustomContent';
export default {
  name: 'EventCollapsableDescriptionComponent',
  components: { HMCustomContent },
  props: {
    descriptionHtml: {
      type: String,
      default: '',
    },
    descriptionJson: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDescription: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.event-description {
  overflow: hidden;
}

.pointer {
  cursor: pointer;
}
</style>
